const tv_signal_quality_chart_options = ({
    data
}) => ({
    title: {
        text: "",
        align: "left"
    },
    chart: {
        panKey: "alt",
        panning: true,
        borderRadius: 8,
    },
    xAxis: {
        type: "datetime",
        ordinal: false,
        gridLineColor: '#D2D8E5',
        lineColor: '#D2D8E5',
        scrollbar: {
            enabled: false
        },
        labels: {
            style: {
                fontFamily: 'Nunito',
                color: '#8F8F8F',
                fontSize: '10px'
            }
        }
    },
    yAxis: {
        gridLineColor: '#D2D8E5',
        lineColor: '#D2D8E5',
        startOnTick: false,
        endOnTick: false,
        labels: {
            y: 4,
            style: {
                fontFamily: 'Nunito',
                color: '#8F8F8F',
                fontSize: '10px'
            }
        }
    },
    series: [{
        name: "Good Signal Duration",
        id: '1',
        connectNulls: true,
        showInLegend: true,
        color: '#053D6E',
        data: data.sq_points
    },
    {
        name: "Total Sleep Time",
        id: '2',
        connectNulls: true,
        showInLegend: true,
        color: '#E27F2A',
        data: data.ts_points  
    },
    {
        name: "Total Bed Time",
        id: '3',
        connectNulls: true,
        showInLegend: true,
        color: '#0E95FC',
        data: data.tb_points 
    },
    {
        name: "Total Breathing Time",
        id: '4',
        connectNulls: true,
        showInLegend: true,
        color: '#73d862',
        data: data.tbr_points 
    }],
    labels: {
        overflow: "scroll"
    },
    navigator: {
        enabled: false
    },
    scrollbar: {
        enabled: false
    },
    plotOptions: {
        series: {
            pointPadding: 0,
            groupPadding: 0,
            gapSize: 0,
            name: "",
            events: {
                legendItemClick: function() {
                    if (this.series) {
                        if (this.visible) {
                            this.series.id.hide();
                        } else {
                          this.series.id.show();
                        }
                    }
                }
            }
        },
        line: {
            marker: {
                enabled: true,
                radius: 4,
                lineColor: '#666666',
                lineWidth: 0.5,
            }
        }
    },
    exporting: {
        enabled: true
    }
});

export default tv_signal_quality_chart_options;
